import { useIntl } from 'react-intl'

import { DASH_SYMBOL } from 'app/consts'
import { shouldShowDeviceIP } from '../../../utils'
import DeviceWhiteCardSection from '../../components/DeviceWhiteCardSection'
import { homeDeviceInformationMessages as messages } from '../../messages'
import { UiComponentProps } from '../../types'

function UIIPAddress({ uiDevice }: UiComponentProps) {
  const { formatMessage } = useIntl()
  const ipAddress = uiDevice?.IPAddress?.value

  if (uiDevice) {
    const value = shouldShowDeviceIP(ipAddress) ? ipAddress : DASH_SYMBOL

    return (
      <DeviceWhiteCardSection
        title={formatMessage(messages.deviceIPAddress)}
        value={value}
      />
    )
  }

  return null
}

export default UIIPAddress
